var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumbs"},_vm._l((_vm.items),function(item){return _c('li',{key:item.url,staticClass:"breadcrumb-item"},[(item.url && item.url.length > 0)?_c('a',{staticClass:"breadcrumb-link",attrs:{"href":item.url}},[_vm._v(_vm._s(item.label))]):_c('span',{staticClass:"breadcrumb-text"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }